import React, { useEffect, useState } from "react";
import LTLogo from "./LTLogo";
import { Menu, X } from "lucide-react";

const links = [
  { href: "/#services", label: "Services" },
  { href: "/#work", label: "Work" },
  { href: "/showcase", label: "Showcase" },
  { href: "/#process", label: "Process" },
  { href: "/#about", label: "About" },
  { href: "/#contact", label: "Contact" },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[rgba(250,246,244,0.86)] backdrop-blur-md border-b border-[var(--lt-line)]"
          : "bg-transparent"
      }`}
    >
      <div className="container mx-auto px-6 lg:px-10">
        <div className="h-20 flex items-center justify-between">
          <LTLogo dataTestid="nav-logo" variant="nav" height={56} />

          <nav className="hidden lg:flex items-center gap-10">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="lt-link text-sm tracking-[0.06em] text-[var(--lt-charcoal)]/80 hover:text-[var(--lt-charcoal)]"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:block">
            <a
              href="/#contact"
              data-testid="nav-cta-book-call"
              className="inline-flex items-center gap-2 bg-[var(--lt-charcoal)] text-[var(--lt-peace)] px-5 py-3 text-xs uppercase tracking-[0.22em] hover:bg-[var(--lt-bark)] transition-colors duration-300"
            >
              Book a Call
              <span aria-hidden>↗</span>
            </a>
          </div>

          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 text-[var(--lt-charcoal)]"
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden bg-[var(--lt-peace)] border-t border-[var(--lt-line)]"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className="font-display italic text-2xl text-[var(--lt-charcoal)]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="/#contact"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta-book-call"
              className="mt-4 inline-flex items-center justify-center bg-[var(--lt-charcoal)] text-[var(--lt-peace)] px-5 py-4 text-xs uppercase tracking-[0.22em]"
            >
              Book a Call ↗
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
